// ESM-Huelle um lib/scripts/CLS_CFileHandler.js (Phase 4, Welle 1c).
// Der Prototype-Stil bleibt vorerst (677 Zeilen; class-Umformung folgt
// als eigener, kleiner geschnittener Schritt) - wichtig ist der Umzug
// in den Bundle-/Modul-Scope.
//******************************************************************************
// CFileHandler
//******************************************************************************
// Description:
//      Provides methods to handle files.
// Parameters:
//      filename - The name of the file to be handled.
//******************************************************************************

// *** Constructor ***


// Strict-Mode-Fix (ESM): diese Namen wurden im Classic-Sloppy-Mode als
// implizite window-Globals angelegt (Zuweisung ohne var) - in Modulen
// wirft das ReferenceError. Modul-weite Deklaration stellt das alte
// Verhalten (dateiuebergreifend ungenutzte Temp-Variablen) her.
var readAll;


function CFileHandler(fileName, create, absolute) {
	this.file = null;
	this.inputStream = null;
	this.binaryInputStream = null;

	if (typeof fileName != "undefined") {
		this.fileName = fileName;
		this.open(create, absolute);
	}
}


// ***

// *** Class methods ***
//------------------------------------------------------------------------------
// Description:
//      Opens a file. Creates the file, if it does not exist.
//------------------------------------------------------------------------------
CFileHandler.prototype.open = function (create, absolute) {
	try {
		return true;
		/*if (typeof create == "undefined")
			create = false;


		//var myURL = this.getMyDir();
		var myURL ="/home/pos";
		var fp = null;

		if (typeof absolute != "undefined" && absolute == true)
			fp = this.fileName;
		else
			fp = myURL + "/" + this.fileName;

		if (!fs.existsSync(fp) && create){
			// fp.create(Components.interfaces.nsIFile.NORMAL_FILE_TYPE, 0640);
			var fd = fs.openSync(fp, 'w'); //create
			fs.closeSync(fp);
			}

		if (!fs.existsSync(fp))
			return false;

		this.file = fp;*/
		//this.fileName = fp;

		return true;
	} catch (e) {
		return false;
	}
}
//------------------------------------------------------------------------------

CFileHandler.prototype.accessSync = function (file) {//dummy implementation 
	if  (fs.existsSync(file)){
		return true;
	} else {
	    throw new Error();
	}
	return true;
}


CFileHandler.prototype.existsSync = function (file) {

	file = fs.absPath(file);
    var responsetext = $.ajax({
        type: "GET",
        url: "file",
        async: false,
 data: {
        "file": file,
        "text": "",
    	"type": "e"
    },
  	cache: false,
    }).responseText;
  if (responsetext === "OK") {
	return true;
	} else {
	return false;
  }
}

CFileHandler.prototype.unlinkSync = function (file) {

	file = fs.absPath(file);

 return $.ajax({
    url: "file",
    data: {
        "file": file,
        "text": "",
        "type": "d"
    },
    async : false,
    cache: false,
    type: "POST",
  }).responseText;

}



CFileHandler.prototype.readFileSync = function (file) {

/*    return $.ajax({
        type: "GET",
        url: file,
        async: false
    }).responseText;*/
	file = fs.absPath(file);

return $.ajax({
    url: "file",
    data: {
        "file": file,
        "type": "r"
    },
    async : false,
    cache: false,
    type: "POST",
  }).responseText;

}

CFileHandler.prototype.writeFileSyncHex = function (file, text) {
	file = fs.absPath(file);

        return $.ajax({
    url: "file",
    data: {
        "file": file,
        "text": text,
        "type": "h"
    },
    async : false,
    cache: false,
    type: "POST",
  }).responseText;
}



CFileHandler.prototype.writeFileSync = function (file, text) {
	file = fs.absPath(file);

	return $.ajax({
    url: "file",
    data: {
        "file": file,
        "text": text,
        "type": "w"
    },
    async : false,
    cache: false,
    type: "POST",
  }).responseText;
}


CFileHandler.prototype.writeFile = function (file, text) {

	file = fs.absPath(file);

var defret = $.Deferred();
$.ajax({
    url: "file",
    data: { 
        "file": file, 
        "text": text, 
        "type": "w"
    },
    cache: false,
    type: "POST",
    success: function(response) {
	defret.resolve();
    },
    error: function(xhr) {
	defret.resolve();
    }
});

  return defret.promise();
}


CFileHandler.prototype.append = function (text) {
	this.appendFile(this.fileName,text);
}

CFileHandler.prototype.appendFile = function (file, text) {

	file = fs.absPath(file);

var defret = $.Deferred();
$.ajax({
    url: "file",
    data: {
        "file": file,
        "text": text,
        "type": "a"
    },
    cache: false,
    type: "POST",
    success: function(response) {
	 defret.resolve();
    },
    error: function(xhr) {
	 defret.resolve();
    }
});
return defret.promise();
}

CFileHandler.prototype.appendFileSync = function (file, text) {

	file = fs.absPath(file);

 return $.ajax({
    url: "file",
    data: {
        "file": file,
        "text": text,
        "type": "a"
    },
    async : false,
    cache: false,
    type: "POST",
  }).responseText;

}




CFileHandler.prototype.appendFileSyncHex = function (file, text) {

	file = fs.absPath(file);

 return $.ajax({
    url: "file",
    data: {
        "file": file,
        "text": text,
        "type": "ah"
    },
    async : false,
    cache: false,
    type: "POST",
  }).responseText;

}




CFileHandler.prototype.readdir = function (file, callback) {

	file = fs.absPath(file);
 if (!(file.endsWith("/"))){
                file=file+"/";
        }

var defret = $.Deferred();
$.ajax({
    url: "file",
    data: {
        "file": file,
        "text": "",
        "type": "dir"
    },
    cache: false,
    type: "POST",
    success: function(response) {
	response = response.split("\n");
	callback(null,response)
         defret.resolve();
    },
    error: function(xhr) {
	callback("error",null);
         defret.resolve();
    }
});
return defret.promise();
}


CFileHandler.prototype.readdirSync = function (file, text) {

	file = fs.absPath(file);
return $.ajax({
    url: "file",
    data: {
        "file": file,
        "text": "",
        "type": "dir"
    },
    cache: false,
    type: "POST",
   async: false
}).responseText;
}



//------------------------------------------------------------------------------
CFileHandler.prototype.deleteFile = function (file) {
	/*privMan.enablePrivilege (privList);*/
if (!file){
	file=fs.fileName;
} 

	file = fs.absPath(file);
return this.unlinkSync(file);
/*

	var myURL = this.getMyDir();
	var fp = null;

	if (typeof absolute != "undefined" && absolute == true)
		fp = this.fileName;
	else
		fp = myURL + "/" + this.fileName;
-
	if (fs.existsSync(fp))
		fs.unlinkSync(fp); //remove
	// fp.remove(true);*/
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
CFileHandler.prototype.getUri = function () {
	/*privMan.enablePrivilege (privList);*/
	/*
	var conv = Components.classes["@mozilla.org/network/protocol;1?name=file"].
	createInstance (Components.interfaces.nsIFileProtocolHandler);
	 */
	return ("file://" + this.file);
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Pfad-Normalisierung fuer ALLE Dateizugriffe der Kasse.
// Zwei Faelle, die es vorher nur halb gab:
//  - relativer Pfad ("var/db/import/POSId"): wie bisher an getMyDir() haengen.
//  - file://-URL: AUFLOESEN. Die Kasse schickt solche URLs an mehreren
//    Stellen (CLoginScreen.testAlarm liest file:///home/pos/src/POSAlarm/...).
//    Sie beginnen nicht mit "/", wurden deshalb ebenfalls an getMyDir()
//    gehaengt und ergaben "/home/pos/file:///home/pos/src/..." - einen Pfad,
//    den es nie gibt. Folge war (gefunden 21.8.2026): testAlarm() konnte die
//    Alarmdateien nie lesen, lieferte immer true, und ab ALARMBEGIN (22:00)
//    scheiterte JEDER Login mit "Der Alarm wurde rechtzeitig deaktiviert."
CFileHandler.prototype.absPath = function (file) {
	if (typeof file != "string")
		return file;

	if (file.startsWith("file://"))
		return decodeURIComponent(file.replace(/^file:\/\/(localhost)?/, ""));

	if (!file.startsWith("/"))
		return fs.getMyDir() + file;

	return file;
}

CFileHandler.prototype.getMyDir = function () {
	/*privMan.enablePrivilege (privList);*/
	//var myURL = process.cwd(); //(process.env.HOME || process.env.HOMEPATH || process.env.USERPROFILE);
	var myURL ="/home/pos/";
	/*  var myURL = window.location.toString ();

	if (myURL.indexOf ("?") != -1)
	myURL = myURL.replace (/\?.   //*///, "");

	// myURL = myURL.replace ("/index.html", "");*/

	return myURL;
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
CFileHandler.prototype.getMyCleanDir = function () {
	var MyDir = this.getMyDir();

	MyDir = unescape(MyDir);
	MyDir = MyDir.replace("file:///", "");

	return MyDir;
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
CFileHandler.prototype.createDir = function (path, dir) {
	/*privMan.enablePrivilege (privList);*/

	var myURL = this.getMyDir();
	/*
	var conv = Components.classes["@mozilla.org/network/protocol;1?name=file"].
	createInstance (Components.interfaces.nsIFileProtocolHandler);
	 */

	var fp = myURL + "/" + path + "/" + dir;
	if (!fs.existsSync(fp)) {
		try {
			fs.mkdirSync(fp);
		} catch (e) {
			if (e.code != 'EEXIST')
				throw e;
		}

	}
	/*
	if (!fp.exists ())
	fp.create(Components.interfaces.nsIFile.DIRECTORY_TYPE, 0740);
	 */
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Opens a file and appends 'str'. Creates the file, if it does not exist.
//------------------------------------------------------------------------------
/*
CFileHandler.prototype.append = function (str) {
	fs.appendFile(this.fileName, str, function (err) {
		if (err)
			console.log(err);

	});

}

CFileHandler.prototype.appendSync = function (str) {
	fs.appendFileSync(this.fileName, str);

}
*/
CFileHandler.prototype.overwrite = function (str) {
	return this.writeFile(this.fileName, str);
/* function (err) {
		if (err)
			console.log(err);

	});*/
}

CFileHandler.prototype.overwriteSync = function (str) {
	this.writeFileSync(this.fileName, str);
}

CFileHandler.prototype.binaryOverwrite = function (str) {
	var wstream = fs.createWriteStream(this.fileName);
	wstream.write(str);
	wstream.end();
}

CFileHandler.prototype.readOpen = function () {
	/*privMan.enablePrivilege (privList);*/
	/*
	var fileStream = Components.classes["@mozilla.org/network/file-input-stream;1"].createInstance (Components.interfaces.nsIFileInputStream);

	fileStream.init (this.file, 0x01, null, 0);

	this.inputStream = Components.classes["@mozilla.org/scriptableinputstream;1"].
	createInstance (Components.interfaces.nsIScriptableInputStream);

	this.inputStream.init(fileStream);
	 */

	this.inputStream = fs.createReadStream(this.fileName);

}

CFileHandler.prototype.readAll = function () {
	/*privMan.enablePrivilege (privList);*/
	/*
	var data = this.inputStream.read (this.file.fileSize);

	this.readClose ();

	return data;
	 */

	return fs.readFileSync(this.fileName, "utf-8");
	/*   var data = '';
	readableStream.on('readable', function () {
	while ((chunk = readableStream.read()) != null) {
	data += chunk;
	}
	});

	readableStream.on('end', function () {
	console.log(data);
	});

	return data;*/

}

CFileHandler.prototype.readAllAsBase64 = function () {
	/*var b;
	var result = "";

	while (this.inputStream.available ()){
	var data = new Array ();

	while (data.length < 255 && this.inputStream.available ()){
	b = this.inputStream.read (1).charCodeAt (0);
	data.push (isNaN (b) ? 0 : b);
	}

	result += this.toBase64 (data);
	}

	return result;*/
	var data = readAll();
	var b = new Buffer(data);
	var s = b.toString('base64');
	return s;
}

CFileHandler.prototype.readClose = function () {
	this.inputStream.close();
}

CFileHandler.prototype.Close = function () {
	try {
		fs.close(this.fileName);
	} catch (e) {}
}

CFileHandler.prototype.closeSync = function () {
	try {
		fs.closeSync(this.fileName);
	} catch (e) {}
}



CFileHandler.prototype.rename = function (file,newfile) {
	file = fs.absPath(file);
	newfile = fs.absPath(newfile);


 return $.ajax({
    url: "file",
    data: {
        "file": file,
        "newfile": newfile,
        "type": "rn"
    },
    async : false,
    cache: false,
    type: "POST",
  }).responseText;

}


CFileHandler.prototype.copy = function (file,newfile) {
	file = fs.absPath(file);
	newfile = fs.absPath(newfile);


 return $.ajax({
    url: "file",
    data: {
        "file": file,
	"newfile": newfile,
        "type": "cp"
    },
    async : false,
    cache: false,
    type: "POST",
  }).responseText;

}



CFileHandler.prototype.copyTo = function (newName) {
	try {
	newName = fs.absPath(newName);
		fs.writeFileSync(newName, fs.readFileSync(this.fileName));
		// this.file.copyTo(null, newName);
	} catch (e) {
		alert("File copy error! " + e);
	}
}

CFileHandler.prototype.toBase64 = function (data) {
	const toBase64Table = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdef" +
		"ghijklmnopqrstuvwxyz0123456789+/";
	const base64Pad = "=";

	var result = '';
	var length = data.length;
	var i;

	for (i = 0; i < (length - 2); i += 3) {
		result += toBase64Table[data[i] >> 2];
		result += toBase64Table[((data[i] & 0x03) << 4) + (data[i + 1] >> 4)];
		result += toBase64Table[((data[i + 1] & 0x0f) << 2) + (data[i + 2] >> 6)];
		result += toBase64Table[data[i + 2] & 0x3f];
	}

	if (length % 3) {
		i = length - (length % 3);
		result += toBase64Table[data[i] >> 2];
		if ((length % 3) == 2) {
			result += toBase64Table[((data[i] & 0x03) << 4) + (data[i + 1] >> 4)];
			result += toBase64Table[(data[i + 1] & 0x0f) << 2];
			result += base64Pad;
		} else {
			result += toBase64Table[(data[i] & 0x03) << 4];
			result += base64Pad + base64Pad;
		}
	}

	return result;
}
//------------------------------------------------------------------------------
// ***
//@ sourceURL=CLS_CFileHandler.js


/*
 *** Open flags ***

#define PR_RDONLY       0x01
#define PR_WRONLY       0x02
#define PR_RDWR         0x04
#define PR_CREATE_FILE  0x08
#define PR_APPEND      0x10
#define PR_TRUNCATE     0x20
#define PR_SYNC         0x40
#define PR_EXCL         0x80

 *** File modes ***
CAVEAT: 'mode' is currently only applicable on UNIX platforms.
The 'mode' argument may be ignored by PR_Open on other platforms.

00400   Read by owner.
00200   Write by owner.
00100   Execute (search if a directory) by owner.
00040   Read by group.
00020   Write by group.
00010   Execute by group.
00004   Read by others.
00002   Write by others
00001   Execute by others.
*/

export { CFileHandler };
